import LogList from "./components/List"

const meta = {
  module: "logs"
}

let module = "logs"

export default [
  {
    path: "logs",
    component: LogList,
    meta: { module: module, permissions: ["log-access"] }
  }
]
